<template>
  <div>
    <div>
      <span v-if="labelTitulo">{{ labelTitulo }}</span>
      <div v-if="!corSelecionada" class="component-sem-cor" @click="abrirColorPicker">
        <label>sem cor selecionada...</label>
      </div>
      <div v-else
           class="component-cor"
           :style="`--cor-selecionada: ${corSelecionada}`"
           @click="abrirColorPicker"/>
    </div>
    <ColorPickerModal
        v-if="exibirColorPicker"
        v-model="exibirColorPicker"
        :cor-padrao="corSelecionada"
        :permite-transparencia="permiteTransparencia"
        @cancelarSelecionarCor="fecharColorPickar"
        @confirmarSelecionarCor="alterarCor"
    />
  </div>
</template>


<script>
import ColorPickerModal from '@/views/components/ColorPickerModal.vue'

export default {
    name: 'ColorSelect',
    components: {ColorPickerModal},
    props: {
        labelTitulo: String,
        corSelecionada: String,
        apenasVisualizar: {
            type: Boolean,
            default: false
        },
        permiteTransparencia: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            exibirColorPicker: false,
        }
    },
    methods: {
        abrirColorPicker() {
            if (this.apenasVisualizar) return
            this.exibirColorPicker = true
        },
        fecharColorPickar() {
            this.exibirColorPicker = false
        },
        alterarCor(novaCor) {
            this.$emit('atualizarCor', novaCor)
            this.fecharColorPickar()
        },
    }
}
</script>

<style scoped lang="stylus">

.component-sem-cor
  border-radius 10px
  height 20px
  width 200px
  background-color #eee
  padding-left 10px

  label
    font-weight normal
    font-size 14px

.component-cor
  border-radius 10px
  height 20px
  width 200px
  background-color var(--cor-selecionada)

.component-cor:hover, .component-sem-cor:hover
  cursor pointer
  border 1px solid #1e1e1e

</style>